import React from "react";
import User from "./User";

export default ({userIds}) => userIds.map(userId => <User key={userId} userId={userId}/>)
